import { render, staticRenderFns } from "./PersonalData.vue?vue&type=template&id=00da6ecd&"
import script from "./PersonalData.ts?vue&type=script&lang=ts&"
export * from "./PersonalData.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports